export function EmailCompliancePage() {
  return (
    <div className="py-12 bg-cacao-dark">
      <div className="mx-auto max-w-3xl px-4 sm:px-6 lg:px-8">
        <h1 className="font-heading text-xl font-semibold text-[#F5F5F5]">Email Compliance</h1>
        <p className="mt-1.5 text-xs text-cacao-text-tertiary">Last updated: March 2, 2026</p>

        <div className="mt-8 space-y-6 text-sm text-cacao-muted leading-relaxed">
          <section>
            <h2 className="text-sm font-medium text-[#F5F5F5]">Our Commitment to Email Best Practices</h2>
            <p className="mt-2">
              Traction Bee is committed to helping users send compliant, professional outreach emails. This page outlines our approach to email compliance.
            </p>
          </section>

          <section>
            <h2 className="text-sm font-medium text-[#F5F5F5]">1. CAN-SPAM Compliance</h2>
            <p className="mt-2">
              All emails sent through Traction Bee must comply with the CAN-SPAM Act. This means:
            </p>
            <ul className="mt-2 list-disc pl-5 space-y-1">
              <li>Accurate "From" and "Reply-To" headers</li>
              <li>Non-deceptive subject lines</li>
              <li>Clear identification as a commercial message where applicable</li>
              <li>Valid physical postal address in email footer</li>
              <li>Clear opt-out mechanism</li>
              <li>Prompt honoring of opt-out requests (within 10 business days)</li>
            </ul>
          </section>

          <section>
            <h2 className="text-sm font-medium text-[#F5F5F5]">2. GDPR Compliance (EU Recipients)</h2>
            <p className="mt-2">
              When contacting recipients in the European Union, users must ensure:
            </p>
            <ul className="mt-2 list-disc pl-5 space-y-1">
              <li>Legitimate interest basis for B2B outreach</li>
              <li>Clear identification of sender</li>
              <li>Easy unsubscribe mechanism</li>
              <li>Respect for data subject rights</li>
            </ul>
          </section>

          <section>
            <h2 className="text-sm font-medium text-[#F5F5F5]">3. CASL Compliance (Canadian Recipients)</h2>
            <p className="mt-2">
              When contacting recipients in Canada, users should be aware of Canada's Anti-Spam Legislation (CASL) requirements for commercial electronic messages.
            </p>
          </section>

          <section>
            <h2 className="text-sm font-medium text-[#F5F5F5]">4. Traction Bee Safeguards</h2>
            <p className="mt-2">We provide tools to help maintain compliance:</p>
            <ul className="mt-2 list-disc pl-5 space-y-1">
              <li><strong className="text-[#F5F5F5]">Do Not Contact List:</strong> Maintain a list of recipients who should never be contacted</li>
              <li><strong className="text-[#F5F5F5]">Unsubscribe Handling:</strong> Automatic processing of opt-out requests</li>
              <li><strong className="text-[#F5F5F5]">Rate Limiting:</strong> Prevents excessive sending that could harm deliverability</li>
              <li><strong className="text-[#F5F5F5]">Domain Warming:</strong> Gradual increase in sending volume for new accounts</li>
              <li><strong className="text-[#F5F5F5]">Human Review:</strong> All emails require manual approval before sending</li>
            </ul>
          </section>

          <section>
            <h2 className="text-sm font-medium text-[#F5F5F5]">5. User Responsibilities</h2>
            <p className="mt-2">As a Traction Bee user, you agree to:</p>
            <ul className="mt-2 list-disc pl-5 space-y-1">
              <li>Only contact recipients with a legitimate business purpose</li>
              <li>Not send misleading or deceptive content</li>
              <li>Honor all opt-out requests promptly</li>
              <li>Maintain accurate sender information</li>
              <li>Comply with applicable laws in recipient jurisdictions</li>
            </ul>
          </section>

          <section>
            <h2 className="text-sm font-medium text-[#F5F5F5]">6. Prohibited Activities</h2>
            <p className="mt-2">The following are strictly prohibited:</p>
            <ul className="mt-2 list-disc pl-5 space-y-1">
              <li>Sending spam or unsolicited bulk email</li>
              <li>Using purchased email lists</li>
              <li>Impersonating other individuals or companies</li>
              <li>Sending malicious content or phishing attempts</li>
              <li>Violating any applicable anti-spam laws</li>
            </ul>
          </section>

          <section>
            <h2 className="text-sm font-medium text-[#F5F5F5]">7. Enforcement</h2>
            <p className="mt-2">
              Violations of this policy may result in account suspension or termination. We reserve the right to investigate complaints and take appropriate action.
            </p>
          </section>

          <section>
            <h2 className="text-sm font-medium text-[#F5F5F5]">8. Reporting Concerns</h2>
            <p className="mt-2">
              To report email compliance concerns or abuse, contact us at{' '}
              <a href="mailto:abuse@tractionbee.com" className="text-cacao-gold hover:text-cacao-gold-hover transition-colors">abuse@tractionbee.com</a>.
            </p>

            <p className="mt-6 text-xs text-cacao-text-tertiary">
              <strong className="text-cacao-muted">Traction Bee</strong><br />
              26565 Agoura Road, Suite 200<br />
              Calabasas, CA 91302 USA
            </p>
          </section>
        </div>
      </div>
    </div>
  );
}
